/*!

=========================================================
* Argon Dashboard React - v1.2.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Avatar from "react-avatar";
import { useQueryClient } from "react-query";
import { useHistory, useLocation } from "react-router-dom";
import {
  Container, DropdownItem, DropdownMenu, DropdownToggle, Media, Nav, Navbar, UncontrolledDropdown
} from "reactstrap";
import { useCurrentUser } from "../../hooks/useCurrentUser";
import { clearAuthCache, logoutSso } from "../../utils/authProvider";
// import { getAuth, signOut } from "firebase/auth";

const AdminNavbar: React.FC = () => {
  const { data } = useCurrentUser()
  let headerText = 'Dashboard'
  const { pathname } = useLocation()
  if (pathname.includes('/project/')) {
    headerText = 'Project Details'
  }
  if (pathname === '/admin/monitor') {
    headerText = 'Monitor'
  }
  if (pathname === '/admin/scheduler') {
    headerText = 'Scheduler'
  }
  if (pathname === '/admin/historicalExecutions') {
    headerText = 'Audit'
  }
  if (pathname === '/admin/reports') {
    headerText = 'Report'
  }
  const queryClient = useQueryClient()
  const router = useHistory()
  const handleLogout = async () => {
    try {
      await logoutSso();
      queryClient.clear();
      router.replace("/auth/login");
    } catch (error) {
      console.error("Logout failed:", error);
      await clearAuthCache();
      queryClient.clear();
      router.replace('/auth/login');
    }
  };

  return (
    <>
      <Navbar className="navbar-top navbar-dark" expand="md" id="navbar-main">
        <Container fluid>
          <h4
            className="h4 mb-0 text-white text-uppercase d-none d-md-inline-block"
          >
            {headerText}
          </h4>
          {/* <Form className="navbar-search navbar-search-dark form-inline mr-3 d-none d-md-flex ml-lg-auto">
            <FormGroup className="mb-0">
              <InputGroup className="input-group-alternative">
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>
                    <i className="fas fa-search" />
                  </InputGroupText>
                </InputGroupAddon>
                <Input placeholder="Search for a project" type="text" />
              </InputGroup>
            </FormGroup>
          </Form> */}
          <Nav className="align-items-center d-none d-md-flex" navbar>
            <UncontrolledDropdown nav>
              <DropdownToggle className="pr-0" nav>
                <Media className="align-items-center">
                  <Avatar name={data?.name} size="36" className="avatar rounded-circle" />
                  <Media className="ml-2 d-none d-lg-block">
                    <span className="mb-0 text-sm font-weight-bold">
                      {data?.name}
                    </span>
                  </Media>
                </Media>
              </DropdownToggle>
              <DropdownMenu className="dropdown-menu-arrow" right>
                <DropdownItem className="noti-title" header tag="div">
                  <h6 className="text-overflow m-0">Welcome, {data?.name}!</h6>
                </DropdownItem>
                {/* <DropdownItem>
                  <i className="ni ni-single-02" />
                  <span>My profile</span>
                </DropdownItem>
                <DropdownItem to="/admin/user-profile" tag={Link}>
                  <i className="ni ni-settings-gear-65" />
                  <span>Settings</span>
                </DropdownItem> 
                <DropdownItem to="/admin/user-profile" tag={Link}>
                  <i className="ni ni-calendar-grid-58" />
                  <span>Activity</span>
                </DropdownItem>
                <DropdownItem to="/admin/user-profile" tag={Link}>
                  <i className="ni ni-support-16" />
                  <span>Support</span>
                </DropdownItem> */}
                <DropdownItem divider />
                <DropdownItem onClick={handleLogout}>
                  <i className="ni ni-user-run" />
                  <span>Logout</span>
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </Nav>
        </Container>
      </Navbar>
    </>
  );
};

export default AdminNavbar;
